import { jsx as a } from "react/jsx-runtime";
import m from "@mui/material/SvgIcon";
import * as o from "react";
import { forwardRef as c } from "react";
const l = (e) => /* @__PURE__ */ o.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "6 8 20 16", ...e }, /* @__PURE__ */ o.createElement("path", { fill: "currentColor", d: "m12.434 23.749-6.2-6.646a.903.903 0 0 1 0-1.213l1.132-1.214a.76.76 0 0 1 1.131 0L13 19.5 23.503 8.251a.76.76 0 0 1 1.131 0l1.132 1.214a.903.903 0 0 1 0 1.214l-12.2 13.07a.76.76 0 0 1-1.132 0" })), f = /* @__PURE__ */ c(({ size: e = "inherit", sx: t, ...r }, n) => {
  const i = typeof t == "function" ? t : {
    fontSize: e,
    ...t
  };
  return /* @__PURE__ */ a(m, {
    ...r,
    ref: n,
    component: l,
    inheritViewBox: !0,
    sx: i
  });
});
f.displayName = "svg_checkmark";
export {
  f as default
};
